<template>
    <div class="c-comments u-m-b5">
        <comment-box></comment-box>
        <div>
            <post-comments
                v-for="comment in comments"
                :key="comment.comment_id"
                :comment="comment"
            ></post-comments>
            <div @click.prevent="moreComments" v-if="this.$root.comments.length > 5 && !showAll" class="u-align-center">
                <button class="c-btn3">More</button>
            </div>
        </div>
    </div>
</template>

<script>
import CommentBox from "./CommentBox.vue";
import PostComments from "./PostComments.vue";

export default {
    components: {
        CommentBox,
        PostComments
    },
    created() {
        this.$root.$on('unshift-comment', (comment) => {
            this.comments.unshift(comment);
        });
        this.$root.$on('unshift-child-comment', (data) => {
            this.traverseComments(this.$root.comments, data);
        });
    },
    data() {
        return {
            Networks: this.$simpleStore.Networks,
            comments: this.$root.comments.slice(0, 5),
            showAll: false
        }
    },
    methods: {
        traverseComments(comments, data) {
            for (let i = 0; i < comments.length; i++) {
                if (parseInt(comments[i].comment_id) === data.parentId) {
                    comments[i].replies.unshift(data.comment);
                } else if (comments[i].replies.length > 0) {
                    this.traverseComments(comments[i].replies, data);
                }
            }
        },
        moreComments() {
            this.showAll = true;
            this.comments = this.$root.comments;
        }
    }
}
</script>
